import { render, staticRenderFns } from "./SentimentList.vue?vue&type=template&id=5b331e9b&"
import script from "./SentimentList.vue?vue&type=script&lang=js&"
export * from "./SentimentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports